module.exports = __webpack_public_path__ + "793b1237017aeacd646fb80911425566.woff";